import script from "./JobsearchResultListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./JobsearchResultListItem.vue?vue&type=script&setup=true&lang=js"

import "./JobsearchResultListItem.vue?vue&type=style&index=0&id=67078665&lang=css"

const __exports__ = script;

export default __exports__